import { useQuery } from "@tanstack/react-query";
import { fetchAiTrends } from "./api";

export const trendsKeys = {
  trends: (scope) => ["aiTrends", scope],
};

// useAiTrends — one query for the whole page. Manual refresh only, matching
// useMonitorSummary's pattern on the Live side. keepPreviousData holds the
// current chart on screen while a new period or breakdown loads, so switching
// metric does not blank the page.
export function useAiTrends(scope, options = {}) {
  return useQuery({
    queryKey: trendsKeys.trends(scope),
    queryFn: () => fetchAiTrends(scope),
    keepPreviousData: true,
    ...options,
  });
}
